import API from "Services/Api";
import { CheckoutRemotePayload, CheckoutRemoteResponse } from "./types";

export const createCheckoutRemote = async (
  payload: CheckoutRemotePayload
): Promise<CheckoutRemoteResponse> => {
  const response = await API.post<CheckoutRemoteResponse>(
    "/checkout-remote",
    payload
  );
  return response.data;
};
